import React from 'react';

export const RefaLogoIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="93" height="30" viewBox="0 0 93 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.32 0.780033C10.9067 0.780033 13.04 1.10003 14.72 1.74003C16.4 2.35337 17.6533 3.30003 18.48 4.58003C19.3067 5.83337 19.72 7.42003 19.72 9.34003C19.72 10.6467 19.4667 11.7934 18.96 12.78C18.48 13.74 17.8267 14.5667 17 15.26C16.2 15.9267 15.3333 16.4734 14.4 16.9L22.8 29.34H16.08L9.28 18.38H6.04V29.34H0V0.780033H8.32ZM7.88 5.74003H6.04V13.46H8C9.33333 13.46 10.4133 13.3134 11.24 13.02C12.0667 12.7267 12.6667 12.2867 13.04 11.7C13.4133 11.0867 13.6 10.3534 13.6 9.50003C13.6 8.59337 13.3867 7.87337 12.96 7.34003C12.56 6.78003 11.9333 6.38003 11.08 6.14003C10.2533 5.87337 9.18667 5.74003 7.88 5.74003Z"
        fill="#333333"
      />
      <path
        d="M42.3463 29.34H25.9062V0.780033H42.3463V5.74003H31.9463V12.02H41.6263V16.98H31.9463V24.34H42.3463V29.34Z"
        fill="#333333"
      />
      <path
        d="M53.7491 29.34H47.7891V0.780033H64.1491V5.74003H53.7491V13.1H63.4291V18.06H53.7491V29.34Z"
        fill="#333333"
      />
      <path
        d="M85.9409 29.34L83.8609 22.54H73.4609L71.3809 29.34H64.8609L74.9409 0.660034H82.3409L92.4609 29.34H85.9409ZM80.3409 10.82C80.2076 10.3667 80.0343 9.79337 79.8209 9.10003C79.6076 8.4067 79.3943 7.70003 79.1809 6.98003C78.9676 6.26003 78.7943 5.63337 78.6609 5.10003C78.5276 5.63337 78.3409 6.30003 78.1009 7.10003C77.8876 7.87337 77.6743 8.62003 77.4609 9.34003C77.2743 10.0334 77.1276 10.5267 77.0209 10.82L74.9809 17.46H82.4209L80.3409 10.82Z"
        fill="#333333"
      />
    </svg>
  );
};
